var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 25C2.70833 25 1.82292 24.6354 1.09375 23.9062C0.364583 23.1771 0 22.2917 0 21.25V3.75C0 2.70833 0.364583 1.82292 1.09375 1.09375C1.82292 0.364583 2.70833 0 3.75 0H21.25C22.2917 0 23.1771 0.364583 23.9062 1.09375C24.6354 1.82292 25 2.70833 25 3.75V21.25C25 22.2917 24.6354 23.1771 23.9062 23.9062C23.1771 24.6354 22.2917 25 21.25 25H3.75ZM3.75 23.125H21.25C21.7917 23.125 22.2396 22.9427 22.5938 22.5781C22.9479 22.2135 23.125 21.7708 23.125 21.25V3.75C23.125 3.20833 22.9479 2.76042 22.5938 2.40625C22.2396 2.05208 21.7917 1.875 21.25 1.875H3.75C3.22917 1.875 2.78646 2.05208 2.42188 2.40625C2.05729 2.76042 1.875 3.20833 1.875 3.75V21.25C1.875 21.7708 2.05729 22.2135 2.42188 22.5781C2.78646 22.9427 3.22917 23.125 3.75 23.125ZM5.75 19.6875L10 15.4375L12.2812 17.6875L15 14.25L19.3438 19.6875H5.75ZM7.5 9.6875C6.89583 9.6875 6.38021 9.47396 5.95312 9.04688C5.52604 8.61979 5.3125 8.10417 5.3125 7.5C5.3125 6.89583 5.52604 6.38021 5.95312 5.95312C6.38021 5.52604 6.89583 5.3125 7.5 5.3125C8.10417 5.3125 8.61979 5.52604 9.04688 5.95312C9.47396 6.38021 9.6875 6.89583 9.6875 7.5C9.6875 8.10417 9.47396 8.61979 9.04688 9.04688C8.61979 9.47396 8.10417 9.6875 7.5 9.6875Z",
    fill: "#007DFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.194c3bea23a4e18b558f8453f7037e5f.svg";
export { ForwardRef as ReactComponent };